(function () {

  function checkShippingManager() {

    const shippingBox = document.querySelector('#haisosm_et');

    if (!shippingBox) return;

    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {

        if (cart.item_count === 0) {
          shippingBox.style.display = 'none';
        } else {
          shippingBox.style.display = '';
        }

      });

  }


  const observer = new MutationObserver(() => {
    checkShippingManager();
  });


  observer.observe(document.body, {
    childList: true,
    subtree: true
  });


  checkShippingManager();

})();

document.addEventListener('DOMContentLoaded', function () {

  const wishlistSelector = '.iwish-float-icon';
  const footer = document.querySelector('footer');

  if (!footer) return;

  function checkWishlistPosition() {

    const icon = document.querySelector(wishlistSelector);

    if (!icon) return;

    const footerPosition = footer.getBoundingClientRect().top;
    const windowHeight = window.innerHeight;

    // フッターが画面下100px以内に入ったら非表示
    if (footerPosition < windowHeight + 100) {
      icon.style.opacity = '0';
      icon.style.pointerEvents = 'none';
    } else {
      icon.style.opacity = '1';
      icon.style.pointerEvents = 'auto';
    }

  }

  window.addEventListener('scroll', checkWishlistPosition);

  // 初期表示時チェック
  checkWishlistPosition();

});